import React from 'react';
import { useRecoilValue } from 'recoil';
import { assetPathFnState, toViewPriceFnState } from '../../recoil/atoms';
import { sizeImage } from '../../util';
import { ViewVariant } from '../../models/ShopifyVariant.model';
import { Pills } from '../../components/Pills';
import styles from './CartItem.module.scss';

interface Props {
  variant: ViewVariant;
}

export const FreeGiftItem: React.FC<Props> = ({ variant }) => {
  const assetPathFn = useRecoilValue(assetPathFnState);
  const toViewPriceFn = useRecoilValue(toViewPriceFnState);
  return (
    <div className={styles.hlCartItem}>
      <div className={styles.hlCartProduct}>
        <div className={styles.hlCartThumbnail} style={{ display: 'flex', width: '90px', border: '1px solid #6261e8' }}>
          <img
            alt="free intimates bag"
            className={styles.hlCartItemImage}
            src={sizeImage(variant.featured_image.src, '180x180')}
            style={{ height: '62px', width: '46px', margin: '4px', marginRight: 0 }}
          />
          <img
            alt="gift bow"
            className={styles.hlCartItemImage}
            src={assetPathFn('free-gift-bow.png')}
            style={{ filter: 'invert(42%) sepia(98%) saturate(3426%) hue-rotate(227deg) brightness(94%) contrast(93%)', transform: 'scaleX(-1)' }}
          />
        </div>
        <div className={styles.hlCartItemDetails}>
          <div className={styles.hlPromoItemType}>Free {variant.name.split(' - ')[0]}</div>
          <div className={styles.hlItemSubtype}>A gift from us</div>
        </div>
      </div>
      <div className={styles.hlItemPrice}>
        <span className={styles.crossout}>{toViewPriceFn(10)}</span>
        <span>{toViewPriceFn(0)}</span>
        <Pills style={{ marginBottom: '0', marginTop: '4px' }} items={['Free gift']} />
      </div>
    </div>
  );
};

export default FreeGiftItem;
